import React from "react";
import SectionHeader from "./SectionHeader";

export default function ContactSection() {
  const [hovered, setHovered] = React.useState(false);
  return (
    <section
      id="contact"
      style={{
        maxWidth: 600,
        margin: "4rem auto 0 auto",
        padding: "0 1rem 3rem 1rem",
        background: hovered ? "#f3f6fa" : "#fff",
        borderRadius: 18,
        boxShadow: "0 2px 12px rgba(37,99,235,0.06)",
        transition: "background 0.22s cubic-bezier(.4,2,.6,1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <SectionHeader title="Contact Me" />
      <h3
        style={{
          fontSize: "1.35rem",
          fontWeight: 700,
          color: "#18181b",
          margin: "1.2rem 0 0.5rem 0",
          textAlign: "center",
        }}
      >
        Let's Work Together
      </h3>
      <p
        style={{
          color: "#374151",
          fontSize: "1.08rem",
          textAlign: "center",
          margin: 0,
          maxWidth: 380,
          marginBottom: "1.5rem",
        }}
      >
        Ready to start your next project? Reach out and let's make something
        great.
      </p>
      <a
        href="mailto:JohnGJackson0@gmail.com?subject=Contact%20from%20Portfolio&body=Hi%20John%2C%0A"
        style={{
          display: "inline-block",
          background: "#2563eb",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.05rem",
          borderRadius: 8,
          padding: "0.85rem 2rem",
          textDecoration: "none",
          marginTop: "0.5rem",
          boxShadow: "0 1px 4px rgba(37,99,235,0.08)",
          transition:
            "background 0.18s, box-shadow 0.18s, transform 0.18s cubic-bezier(.4,2,.6,1)",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = "#1d4ed8";
          e.currentTarget.style.transform = "scale(1.08)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = "#2563eb";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        Email Me
      </a>
      <div
        style={{
          marginTop: "1.8rem",
          color: "#6b7280",
          fontSize: "1.05rem",
          textAlign: "center",
          userSelect: "all",
        }}
      >
        Or email me at{" "}
        <a
          href="mailto:JohnGJackson0@gmail.com"
          style={{
            color: "#2563eb",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          JohnGJackson0@gmail.com
        </a>
      </div>
    </section>
  );
}
